import { Component, OnInit, OnChanges, ViewChild, Inject, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BackgroundDashboardService } from '../../shared/services/backgroundDashboard.service';
import { Router } from '@angular/router';
import { Jsonp } from '@angular/http';

@Component({
    selector: 'app-fee-approval',
    templateUrl: './feeApprovalModel.component.html',
})

export class FeeApprovalModelComponent implements OnInit {
    FeePendingUser: any;
    TotalCost;
    ISDeclineUpdated: boolean = false;


    constructor(public dialogRef: MatDialogRef<FeeApprovalModelComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, public vcRef: ViewContainerRef,
        private _BackgroundDashboardService: BackgroundDashboardService, private _Router: Router) {
        dialogRef.disableClose = true;
        this.FeePendingUser = this.data.newObj;
        this.TotalCost = this.data.newObj.map(res => res.ServiceCost)
            .reduce((a, b) => a + b);
        this.TotalCost = Number(this.TotalCost.toFixed(2));
        localStorage.setItem('NewOrderProcessingService', JSON.stringify(this.data.newObj))
    }

    ngOnInit() {

    }



    PayNow() {
        this.dialogRef.close();
        window.location.href = 'background-login/payment?AdditionFee=Yes'
    }


    Decline() {
        this.ISDeclineUpdated = true

    }

    UpdatePendingFeeApproval() {
        this._BackgroundDashboardService.UpdateFeeApproval(atob(localStorage.getItem('OrderId')), 'denied').
            subscribe(res => this.UpdateFeeApprovalSucess(res), res => this.UpdateFeeApprovalError(res));
    }

    UpdateFeeApprovalSucess(res) {
        this.dialogRef.close();

    }

    Yes() {
        this.UpdatePendingFeeApproval()

    }
    No() {
        this.ISDeclineUpdated = false
    }

    UpdateFeeApprovalError(res) { }
}
